import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import { isMobile } from 'utilities/browser';
import { mustValidatePostalCode, getValidationPostalCodeByCountry } from 'utilities/logicByCountry';
import { throttledGeoAddressScroll } from '../utils/throttledGeoAddressScroll';
import { bufferedSaveAddressInformation } from '../utils/bufferedSaveAddressInformation';

export const useAddress = ({ formActions, handleNextStep, handleSave, userProfile, userProfileForm }) => {
    const { additionalInfo, address, addressNumber, country, nameOfRoad, postalCode, province, typeOfRoad } =
        userProfile;

    const handleAddressUpdate = (field, value) => {
        if ((field === 'province' || field === 'postalCode') && postalCode && province) {
            if (mustValidatePostalCode()) {
                formActions.setValidity('userProfile.postalCode', {
                    zip: getValidationPostalCodeByCountry(userProfile),
                });
            } else {
                formActions.setValidity('userProfile.postalCode', { zip: true });
            }
        }

        if (field === 'nameOfRoad' && nameOfRoad) {
            const exist = address?.includes(nameOfRoad);
            if (!exist) {
                formActions.change('userProfile.address', '');
            }

            if (nameOfRoad.includes('ª')) formActions.change('userProfile.nameOfRoad', nameOfRoad.replace(/ª/g, 'a'));
            if (nameOfRoad.includes('º')) formActions.change('userProfile.nameOfRoad', nameOfRoad.replace(/º/g, ''));
        }

        if (field === 'addressNumber' && addressNumber) {
            const exist = address?.includes(addressNumber);
            if (!exist) {
                formActions.change('userProfile.address', '');
            }

            if (addressNumber.includes('-') || addressNumber.includes(','))
                formActions.change('userProfile.addressNumber', addressNumber.replace(/,|-/g, ' '));
        }

        if (field === 'typeOfRoad' && typeOfRoad) {
            const exist = address?.includes(typeOfRoad);
            !exist && formActions.change('userProfile.address', '');
        }

        if (field === 'additionalInfo' && additionalInfo) {
            if (additionalInfo.includes('ª'))
                formActions.change('userProfile.additionalInfo', additionalInfo.replace(/ª/g, 'a'));
            if (additionalInfo.includes('º'))
                formActions.change('userProfile.additionalInfo', additionalInfo.replace(/º/g, ''));
            if (additionalInfo.includes(','))
                formActions.change('userProfile.additionalInfo', additionalInfo.replace(/,/g, '.'));
        }

        if (!country) {
            formActions.change('userProfile.country', getReferenceCodeByCountry().toUpperCase());
            bufferedSaveAddressInformation(
                { handleNextStep, handleSave, userProfileForm },
                'country',
                getReferenceCodeByCountry().toUpperCase()
            );
        }

        bufferedSaveAddressInformation({ handleNextStep, handleSave, userProfileForm }, field, value);

        typeOfRoad &&
            nameOfRoad &&
            addressNumber &&
            postalCode &&
            country &&
            !isMobile() &&
            throttledGeoAddressScroll();
    };

    return { handleAddressUpdate };
};
